import { Constant } from "@pdfking/tfunc"
export const IsNode = Constant(false)
